import React from "react";

import styled from "@emotion/styled";

import { COLORS } from "shared/config/constants";

import { Header } from "../styled";

const HeaderStepBlocked = styled(Header)`
  text-align: center;
`;

const Message = styled.p`
  text-align: center;
  margin-bottom: 24px;
  color: ${COLORS.gray2};
`;

const MessageLine = styled(Message)`
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 24px;
  }
`;

const StepBlocked = () => {
  return (
    <>
      <HeaderStepBlocked data-testid="step-blocked-header">
        <h1 data-testid="title" className="title">
          Applications can't be started from this link
        </h1>
      </HeaderStepBlocked>
      <MessageLine>
        This property group starts rental applications through its property
        management system.
      </MessageLine>
      <MessageLine>
        Please contact the leasing office for the correct next step. They can send you the correct application link or guide you through the process.
      </MessageLine>
    </>
  );
};

export default StepBlocked;

